export enum ShapeSeatTypes {
  WHEELCHAIR = 'Wheelchair',
  LOVE_SEAT_LEFT = 'LoveSeatLeft',
  LOVE_SEAT_RIGHT = 'LoveSeatRight',
  SEAT_WITH_FOOTSTOOL = 'SeatWithFootstool',
  CON_SEAT = 'ConSeat',
  SEAT = 'Seat',
  NORMAL_CHAIR = 'NormalChair',
  DISABLED = 'Disabled',
  NONE = 'None'
}
